// Codekit -->
// @codekit-prepend "global/vars.js"
// @codekit-prepend "utilities/debounce.js"
// @codekit-prepend "utilities/ajax.js"
// @codekit-prepend "utilities/lazy.js"
// @codekit-prepend "utilities/image-viewer.js"
// @codekit-prepend "utilities/loadIn.js"

// @codekit-prepend "utilities/scroll-to.js"
// @codekit-prepend "components/menu.js"
// @codekit-prepend "components/header-reveal.js"
// @codekit-prepend "components/flickity.js"
// @codekit-prepend "components/photoswipe-gallery.js"
// @codekit-prepend "components/history-counter.js"

// @codekit-append "global/document-ready.js"
// @codekit-append "global/resize.js"

//<- Codekit

//Funcitons start -->

//Menu
menu();


//Header
window.addEventListener("scroll", debounce(headerReveal));

//Example function pullin
// if (typeof hero != "undefined" && hero != null) {
//     heroSize();
// }

//food and drink scroll buttons
if (typeof fdthHeroScrollButton != "undefined" && fdthHeroScrollButton != null) {
    scrollToTarget(fdthHeroScrollButton, fdthHeroScrollTarget);
}

//gallery photoswipe
if (typeof galleryItems != "undefined" && galleryItems != null) {
    openLightBox()
}

if (typeof openingDate != "undefined" && openingDate != null) {
    formatDate()
}

//<-- Funcitons end




//Being rolled into lazyload by Guy
//This pauses videos on page refresh
//Ensures no flash of white
$(window).on("beforeunload", function () {
    //console.log('PAUSE VIDEO');
    $(".vidUnload").each(function () {
        $(this).get(0).pause();
    });
});